import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './Message.css';

const Message = ({ message, isUser, onClickableTextClick }) => {
  // Function to parse and replace <click> tags with clickable span elements
  const parseClickableTags = (text) => {
    // Case-insensitive regex to match <click>content</click>
    const clickRegex = /<click>(.*?)<\/click>/gi;
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = clickRegex.exec(text)) !== null) {
      // Add text before the match
      if (match.index > lastIndex) {
        parts.push({
          type: 'text',
          content: text.substring(lastIndex, match.index)
        });
      }
      
      // Add the clickable part
      parts.push({
        type: 'clickable',
        content: match[1],
        id: `click-${Date.now()}-${Math.random()}`
      });
      
      lastIndex = match.index + match[0].length;
    }
    
    // Add remaining text
    if (lastIndex < text.length) {
      parts.push({
        type: 'text',
        content: text.substring(lastIndex)
      });
    }
    
    return parts.length > 0 ? parts : [{ type: 'text', content: text }];
  };

  const handleClickableClick = (text) => {
    if (onClickableTextClick && typeof onClickableTextClick === 'function') {
      onClickableTextClick(text);
    }
  };

  return (
    <div className={`message ${isUser ? 'message-user' : 'message-bot'}`}>
      <div className="message-wrapper">
        <div className="message-header">
          {!isUser && (
            <div className="message-avatar">
              <img src="/assets/agent-logo.png" alt="Agent" className="agent-avatar-icon" />
            </div>
          )}
          <div className="message-time">
            {new Date(message.timestamp).toLocaleTimeString([], { 
              hour: '2-digit', 
              minute: '2-digit' 
            })}
          </div>
        </div>
        <div className="message-content">
          <div className="message-text">
            {isUser ? (
              message.text
            ) : (
              <>
                {parseClickableTags(message.text).map((part, index) => {
                  if (part.type === 'clickable') {
                    return (
                      <span
                        key={part.id || index}
                        className="clickable-text"
                        onClick={() => handleClickableClick(part.content)}
                        role="button"
                        tabIndex={0}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            handleClickableClick(part.content);
                          }
                        }}
                      >
                        {part.content}
                      </span>
                    );
                  } else {
                    return (
                      <ReactMarkdown 
                        key={index}
                        remarkPlugins={[remarkGfm]}
                        components={{
                          // Custom rendering for better Arabic RTL support
                          p: ({node, ...props}) => <p dir="auto" {...props} />,
                          ol: ({node, ...props}) => <ol dir="auto" {...props} />,
                          ul: ({node, ...props}) => <ul dir="auto" {...props} />,
                          li: ({node, ...props}) => <li dir="auto" {...props} />,
                          td: ({node, ...props}) => <td dir="auto" {...props} />,
                          th: ({node, ...props}) => <th dir="auto" {...props} />,
                          // Open links in a new window
                          a: ({node, ...props}) => <a target="_blank" rel="noopener noreferrer" {...props} />,
                        }}
                      >
                        {part.content}
                      </ReactMarkdown>
                    );
                  }
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Message;

